import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "isActive", "isCurrentPage", "aria-current", "children", "role", "tabIndex"];
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import Link, { LinkPropTypes } from './Link.js';
import { usePrefix } from '../../internal/usePrefix.js';
import { deprecate } from '../../prop-types/deprecate.js';
var HeaderMenuItem = /*#__PURE__*/forwardRef(function HeaderMenuItem(_ref, ref) {
  var _cx;
  var className = _ref.className,
    isActive = _ref.isActive,
    isCurrentPage = _ref.isCurrentPage,
    ariaCurrent = _ref['aria-current'],
    children = _ref.children,
    role = _ref.role,
    tabIndex = _ref.tabIndex,
    rest = _objectWithoutProperties(_ref, _excluded);
  var prefix = usePrefix();
  var resolvedTabIndex = tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0;
  if (isCurrentPage) {
    isActive = isCurrentPage;
  }
  // We set the current class only if `isActive` is passed in and we do
  // not have an `aria-current="page"` set for the breadcrumb item. When this
  // class is added we also set `aria-current` as `true`
  var hasCurrentClass = isActive && ariaCurrent !== 'page';
  var linkClassName = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "--header__menu-item"), true), _defineProperty(_cx, "".concat(prefix, "--header__menu-item--current"), hasCurrentClass), _cx));
  return /*#__PURE__*/React.createElement("li", {
    className: className,
    role: role
  }, /*#__PURE__*/React.createElement(Link, _extends({}, rest, {
    "aria-current": hasCurrentClass ? true : ariaCurrent,
    className: linkClassName,
    ref: ref,
    tabIndex: resolvedTabIndex
  }), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "--text-truncate--end")
  }, children)));
});
HeaderMenuItem.displayName = 'HeaderMenuItem';
export { HeaderMenuItem as default };